import { ENTRY_FEE_EPSON, INITIAL_PURSE_EPSON } from "@/utils/constants";

export const prizeCalculatorEpson = (playersCount: number) => {
  if (!playersCount || playersCount < 60) return [10000]; //first player gets 30.000

  const sideGamesReserved = 10000;
  const prizeScalingRatio: number = 0.15;
  const topPlayers = Math.trunc(playersCount * 0.1); // Top 10% of players

  const players = Array.from({ length: playersCount }, (_, index) => ({
    rank: playersCount - index, // Rank from highest to lowest
    points: 0,
    scale: 0,
    prize: 0,
  }));

  const totalPrizePool =
    ENTRY_FEE_EPSON * playersCount -
    10000 -
    sideGamesReserved +
    INITIAL_PURSE_EPSON; // Total money to distribute

  // Step 1: Set q(1) = 10000
  players[0].prize = 10000; // First place gets $10,000

  // Step 2: Set q(i) = 0 if i > M (initialize prizes for ranks beyond top 10%)
  for (let i = topPlayers; i < playersCount; i++) {
    players[i].prize = 0; // Players outside the top 10% receive nothing
  }

  // Step 3: Calculate points and scales for 2 <= j <= M
  let P = 0; // Total of points for players 2 to M
  for (let j = 2; j <= topPlayers; j++) {
    const scale = Math.max(1, 10 * Math.pow(1 - prizeScalingRatio, j - 2)); // Calculate scale

    players[j - 1].scale = scale; // Save scale to player
    players[j - 1].points = (topPlayers - j + 1) * scale; // Points based on rank
    P += players[j - 1].points; // Sum up points
  }

  // Step 4: Set q(j) = max(50, p(j) / P * totalPrizePool) for 2 <= j <= M
  let Q = 0; // Total of q(j)
  for (let j = 3; j <= topPlayers; j++) {
    players[j - 1].prize = Math.max(
      50,
      (players[j - 1].points / P) * totalPrizePool
    ); // Calculate prize
    Q += players[j - 1].prize; // Sum up q(j)
  }

  // Step 5: Set q(2) = totalPrizePool - Q
  players[1].prize = totalPrizePool - Q; // Adjust prize for 2nd place

  // Ensure that q(2) is at least $50
  players[1].prize = Math.max(players[1].prize, 50);

  // Calculate any needed adjustments if q(2) was set above $50 and update Q
  Q = players
    .slice(1, topPlayers)
    .reduce((sum, player) => sum + player.prize, 0);

  // Return an array of prizes
  return players.map((player) => Math.round(player.prize));
};
